import { useEffect } from 'react'

const KONAMI_SEQUENCE = [
  'ArrowUp', 'ArrowUp',
  'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight',
  'ArrowLeft', 'ArrowRight',
  'KeyB', 'KeyA',
  'Enter'
]

export function konamiCode(onActivate: () => void) {
  let index = 0
  let lastKeyTime = 0

  return (e: KeyboardEvent) => {
    const now = Date.now()

    if (now - lastKeyTime > 2000) {
      index = 0
    }
    lastKeyTime = now

    const key = e.code
    if (key === KONAMI_SEQUENCE[index]) {
      index++
      if (index === KONAMI_SEQUENCE.length) {
        onActivate()
        index = 0
      }
    } else if (key === KONAMI_SEQUENCE[0]) {
      index = 1
    } else {
      index = 0
    }
  }
}

export function useKonamiCode(onActivate: () => void) {
  useEffect(() => {
    const handler = konamiCode(onActivate)
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onActivate])
}